import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "Service/api/api";
import { IAddOwnerShipGroupType, IOwnerShipGroupTypeSearchList } from "Shared/Types/ownerShipGroupType";

const getOwnerShipGroupList = createAsyncThunk(
  "ownerShipGroup/getOwnerShipGroupList",
  async (params: IOwnerShipGroupTypeSearchList | null) => {
    try {
      const response = await api.ownerShipGroup.getOwnerShipGroupList(params);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

const addOwnerShipGroup = createAsyncThunk(
  "ownerShipGroup/addOwnerShipGroup",
  async (data: IAddOwnerShipGroupType, { dispatch }) => {
    try {
      const response = await api.ownerShipGroup.addOwnerShipGroup(data);
      dispatch(getOwnerShipGroupList(null));
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export { addOwnerShipGroup, getOwnerShipGroupList };